/*
 * File: PatientCard.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Creates and styles the appointment patient header in appointment details
 */
import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

// --------------------------------------------

const styles = theme => ({
  root: {
    position: "relative",
    background: theme.palette.background.default,
    boxShadow: "none"
  },
  patientName: {
    fontWeight: 500,
    marginBottom: theme.spacing(-0.5),
    color: theme.palette.secondary.main,
    marginTop: theme.spacing(-2)
  },
  patientAge: {
    fontWeight: 500,
    color: theme.palette.common.black
  }
});

const PatientCard = ({ patient, classes }) => {
  return (
    <React.Fragment>
      <Link to={"/patients/" + patient.patientId + "/patient_home"}>
        {patient && (
          <Typography variant="h5" className={classes.patientName}>
            {patient.patientName}
          </Typography>
        )}
      </Link>
      <Typography variant="h6">{patient.birthdayString}</Typography>
    </React.Fragment>
  );
};

PatientCard.propTypes = {
  classes: PropTypes.object.isRequired,
  patient: PropTypes.object.isRequired
};

export default withStyles(styles)(PatientCard);
